import { useMediaQuery } from '../useMediaQuery';

export function useIsMobile(defaultMatches = false) {
  return useMediaQuery('(max-width: 768px)', defaultMatches);
}
